<template>
    <PageTemplate
        class="template template--content-page"
    >
        <slot name="navigation" />
        <div
            class="template__main-content"
            data-span-all
        >
            <slot name="hero" />
            <slot />
        </div>
    </PageTemplate>
</template>

<style lang="less">
.template.template--content-page {
    .template__main-content {
        max-width: 38.875rem;
        width: 100%;
        margin-left: auto;
        margin-right: auto;

        @media @q-md-min {
            margin-bottom: 8rem;
        }
    }
}

.template.template--content-wide {
    .template__main-content {
        max-width: 56.25rem;
        width: 100%;
        margin: .75rem auto 5rem;

        @media @q-md-min {
            margin: 3rem 0 8rem;
        }
    }
}
</style>
